import React, { useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import Constants from "../../common/Constants";

const MaterialTraceFilterBox = (props) => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [optionValue, setOptionValue] = useState("jobcardrange");
  const [rangeFrom, setRangeFrom] = useState();
  const [rangeTo, setRangeTo] = useState();
  const [materialTraceNo, setMaterialTraceNo] = useState("");

  const handleCancel = () => {
    setRangeFrom("");
    setRangeTo("");
    setOptionValue("");
    setMaterialTraceNo("");
    props.resetFilerBox(false);
    props.resetSearch();
  };

  const handleSearch = () => {
    let filterObj = {};

    if (optionValue === "jobcardrange") {
      filterObj = {
        rangeFrom,
        rangeTo,
      };
    } else {
      filterObj = {
        materialTraceNumber: materialTraceNo,
      };
    }

    props.searchData(filterObj);
  };

  const handleDownload = () => {
    let filterObj = {};
    if (optionValue === "jobcardrange") {
      filterObj = {
        rangeFrom,
        rangeTo,
        download: true,
      };
    } else {
      filterObj = {
        materialTraceNumber: materialTraceNo,
        download: true,
      };
    }
    props.handleDownload(filterObj);
  };

  return (
    <Form noValidate ref={formRef}>
      <Row className="mx-3" xs={12} md={12} lg={12}>
        <>
          <Col className="mx-3" sm={5} md={2} lg={2}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="">
                {t("msg_common.select_filter_option")} :
              </Form.Label>
              <Form.Select
                aria-label="select filter"
                size="md"
                value={optionValue}
                onChange={(e) => setOptionValue(e.target.value)}
              >
                <option value="jobcardrange">
                  {t("msg_common.jobcardrange")}
                </option>
                <option value="materialtracenumber">
                  {t("msg_common.materialtracenumber")}
                </option>
              </Form.Select>
            </Form.Group>
          </Col>
        </>
        {optionValue === "jobcardrange" && (
          <>
            <Col className="mx-3" sm={5} md={2} lg={2}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>{t("msg_common.jobcardrangefrom")}</Form.Label>
                <Form.Control
                  type="text"
                  value={rangeFrom || ""}
                  placeholder="e.g: 20046"
                  onChange={(e) => setRangeFrom(e.target.value)}
                  maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                  required
                />
              </Form.Group>
            </Col>
            <Col className="mx-3" sm={5} md={2} lg={2}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>{t("msg_common.jobcardrangeto")}</Form.Label>
                <Form.Control
                  type="text"
                  value={rangeTo || ""}
                  placeholder="e.g: 20060"
                  onChange={(e) => setRangeTo(e.target.value)}
                  maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                  required
                />
              </Form.Group>
            </Col>
          </>
        )}
        {optionValue === "materialtracenumber" && (
          <>
            <Col className="mx-3" sm={12} md={5} lg={5}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  {" "}
                  {t("msg_common.materialtracenumber")} :
                </Form.Label>
                <Form.Control
                  type="text"
                  value={materialTraceNo || ""}
                  placeholder="e.g: 8723478"
                  onChange={(e) => setMaterialTraceNo(e.target.value)}
                  maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                  required
                />
              </Form.Group>
            </Col>
          </>
        )}
        <Col className="filterbox-btn " sm={6} md={4} lg={4}>
          <Button
            type="button"
            size="md"
            variant="primary"
            className="btn btn-primary btn-xs"
            onClick={() => handleSearch()}
          >
            {t("msg_common.search")}
          </Button>

          <Button
            type="button"
            size="md"
            variant="danger"
            className="btn btn-primary btn-xs"
            onClick={() => handleCancel()}
          >
            {t("msg_common.cancel")}
          </Button>

          <Button
            type="button"
            size="md"
            variant="secondary"
            className="btn btn-primary btn-xs"
            onClick={() => handleDownload()}
          >
            <i className="bi bi-download"> </i>
            {"Export"}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default MaterialTraceFilterBox;
